module.exports = __webpack_public_path__ + "static/img/be42328.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/2.png
// module id = 623
// module chunks = 2